<div [ngbTooltip]="showTooltip ? (fullName ? fullName : formatName()) : ''"
  placement="bottom"
  container="body">
  @if (imgUrlFound && photoUrl) {
    <img class="avatar-image"
      [ngClass]="{'avatar-loading' : isLoading, 'cursor-default' : showDefaultCursor(), 'avatar-xl' : size === 'xl'}"
      [src]="photoUrl"
      (click)="profilePopup()" />
  }
  @if (!imgUrlFound || !photoUrl) {
    <div class="avatar-initials"
          [ngClass]="{'avatar-loading' : isLoading,
          'cursor-default' : showDefaultCursor(),
          'avatar-xl' : size === 'xl',
          'avatar-sm' : size === 'sm',
          'avatar-initials-alt' : isOrg}"
      (click)="profilePopup()">
      {{firstName | limitTo : 1}}{{lastName | limitTo : 1}}
    </div>
  }
</div>
